// App context: the data source, the signed-in person, and the command catalogue (loaded once for members of the firm).
import { createContext, useContext, type ReactNode } from "react";
import type { DataSource } from "../data/source";
import type { CommandSpec, Member } from "../data/types";
import { useLoad } from "../lib/hooks";

export interface AppCtx { ds: DataSource; me: Member; catalogue: Map<string, CommandSpec>; catalogueError?: string; signOut: () => void; switchRole?: (role: string) => void }
const Ctx = createContext<AppCtx | null>(null);

export function useApp(): AppCtx {
  const c = useContext(Ctx);
  if (!c) throw new Error("useApp outside <AppProvider>");
  return c;
}

export function AppProvider({ ds, me, signOut, switchRole, children }: { ds: DataSource; me: Member; signOut: () => void; switchRole?: (role: string) => void; children: ReactNode }) {
  const cat = useLoad(() => (me.role === "client" ? Promise.resolve([]) : ds.catalogue()), [ds, me.userId]);
  const catalogue = new Map((cat.data ?? []).map((c) => [c.name, c]));
  return <Ctx.Provider value={{ ds, me, catalogue, catalogueError: cat.error, signOut, switchRole }}>{children}</Ctx.Provider>;
}
